import { useState } from "react";
import {
  Table,
  Space,
  Button,
  message,
  Modal,
} from "antd";
import TypeProductsModalForm from "./TypeProductsModalForm";
import TypeProductService from "../../../services/typeProductService";
const getColumns = (setTypeProductTarget, showModalForm, showModalDelete) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setTypeProductTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setTypeProductTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
};
export default function TypeProducts({ list = [], getData, settypeProducts }) {
  const [typeProductTarget, setTypeProductTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    TypeProductService.deleteTypeproduct(typeProductTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Tipo de producto eliminado.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              settypeProducts(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("No se pudo obtener la lista de Tipo de productos.", 5);
            });
        } else {
          message.error(
            "No se pudo eliminar la carrera. " + res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setTypeProductTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setTypeProductTarget(null);
        setIsModalFormVisible(false);
        settypeProducts(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de Tipo de productos.", 5);
      });
  };

  const handleCancelForm = () => {
    setTypeProductTarget(null);
    setIsModalFormVisible(false);
  };
  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{ marginBottom: "1em" }}
      >
        +Registrar nuevo Tipo de Producto
      </Button>
      <Table
        columns={getColumns(
          setTypeProductTarget,
          showModalForm,
          showModalDelete
        )}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <TypeProductsModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          typeProductTarget={typeProductTarget}
        />
      ) : null}
      {isModalDeleteVisible ? (
        <Modal
          visible={isModalDeleteVisible}
          title="Eliminar Carrera"
          onOk={handleOkDelete}
          onCancel={handleCancelDelete}
          okText="Aceptar"
          cancelText="Cancelar"
        >
          <p>
            ¿Desea eliminar la carrera{" "}
            <strong>{typeProductTarget?.name}</strong>?
          </p>
        </Modal>
      ) : null}
    </>
  );
}
